import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import Schemas from "schemas";
import styled from "styled-components";

import { DormitoryTab } from "./dormitories-page";
import { DormitorySearchPreview } from "./search-results-page";

import { Control } from "components/ui-kit/control";
import { Breadcrumb, Button, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import { MEAL_PLAN_OPTIONS, resolveFileUrl } from "constants/config";

import BookingsApi from "api/bookings-api";
import DormitoriesApi from "api/dormitories-api";
import RoomsApi from "api/rooms-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useDeviceParams from "hooks/useDeviceParams";
import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms, ERoles } from "types/enums";

type TProps = {
    mode: "create" | "edit";
};

const CreateBookingPage = (props: TProps) => {
    const { t } = useTranslation();

    const { mode = "create" } = props;

    useBodyBackground("white");
    let { dormitoryId, bookingId } = useParams();
    const navigate = useNavigate();
    const { isDesktop } = useDeviceParams();
    const uData = useStorageListener("user", {});

    const booking = useStorageListener(`bookings.${bookingId}`, {});
    if (mode === "edit") {
        dormitoryId = booking.dormitoryId;
    }

    const universities = useStorageListener(`universities`, {});
    const { universityId, details: dormitory, rooms } = useStorageListener(`dormitories.${dormitoryId}`, {});

    const { data, setValue, setValues, clearForm, onSubmit } = useFormControl({
        name: EForms.editBooking,
        schema: Schemas[EForms.editBooking],
    });

    const handlers = {
        submit: async (data) => {
            if (mode === "create") {
                await BookingsApi.createBooking(data);
            } else {
                await BookingsApi.updateBooking(data);
            }
            navigate(-1);
        },
        cancel: () => {
            clearForm();
            navigate(-1);
        },
    };

    // @ts-ignore
    useEffect(async () => {
        if (!dormitory && ((mode === "edit" && !!dormitoryId) || mode === "create")) {
            try {
                await DormitoriesApi.getDormitoryInfo(dormitoryId);
            } catch (error) {
                navigate(`/search`);
            }
        }
    }, [dormitoryId, dormitory, mode]);
    // @ts-ignore
    useEffect(() => {
        if (!dormitory && ((mode === "edit" && !!dormitoryId) || mode === "create")) {
            RoomsApi.getDormitoryRooms(dormitoryId);
        }
    }, [dormitoryId, dormitory, mode]);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    // @ts-ignore
    useEffect(() => {
        if (mode === "edit" && !booking.dormitoryId) {
            BookingsApi.getMyBookings();
        }
    }, [bookingId, mode]);

    useEffect(() => {
        console.log('11) uData = ', uData);
        if (mode === "edit" && !!booking.dormitoryId) {
            console.log('setting values! booking = ', booking);
            let xBooking = booking;
            if (xBooking.studentsList == undefined){
                xBooking.studentsList = '';
            }
            if (xBooking.files == undefined){
                xBooking.files = [];
            }
            // if (xBooking.author == undefined){
            //     xBooking.author = {};
            // }
            // if (xBooking.author.name == undefined && uData?.name != undefined && uData.name != ''){
            //     xBooking.author.name = uData?.name;
            // }
            setValues(xBooking);
        }
        if (mode == 'create'  && uData?.name != undefined && uData.name != ''){
            setValue('author.name', uData.name);
        }
    }, [booking?.dormitoryId, mode, uData]);

    const typesOptions = _.values(rooms)?.map?.((x) => ({ value: x.id, label: x?.details?.type }));

    console.log('CreateBookingPage: data = ', data);
    let dateRange = _.get(rooms, `${data?.roomId}.details.dateRange`);
    let details = _.get(rooms, `${data?.roomId}.details`);
    console.log('CreateBookingPage: dateRange = ', dateRange);
    console.log('CreateBookingPage: details = ', details);
    if (details?.isAlwaysAvailable == true){
        dateRange = {from: +new Date(), to: +new Date() + 1000 * 60 * 60 * 24 * 365};
    }

    return (
        <Container extra={`align-items: flex-start; h1 { margin-top: 0; };`} key={bookingId || 'dd'} >
            <Breadcrumb.Wrapper>
                <Breadcrumb.Item to="/">{t("zvktc2zl7d")}</Breadcrumb.Item>
                <Breadcrumb.Item to="/search">{t("1rlbp42ao54")}</Breadcrumb.Item>
            </Breadcrumb.Wrapper>
            <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                {t("zddij9ub5b")}
            </DormitoryTab.Link>
            <h1>{t("cbjl9lhxu57")}</h1>
            <RowWrapper extra={`gap: 15px; align-items: flex-start;`}>
                <Control.Form name={EForms.editBooking} onSubmit={onSubmit(handlers.submit)} extra={`margin-bottom: 10px;`}>
                    <Control.Row>
                        <Control.Select
                            name="roomId"
                            label={t("spap9wddjzg")}
                            // options={Object.entries(rooms ?? {}).map(([id, { details }]: any[]) => ({ value: id, label: details?.type }))}
                            options={typesOptions}
                            extra="flex: 2;"
                            isRequired
                        />
                        <Control.Input
                            name="quantity"
                            label={t("9cvedv9yb7m")}
                            placeholder={t("9f441w70phs")}
                            regex="[^0-9.]"
                            extra="flex: 1;"
                            isRequired
                        />
                    </Control.Row>
                    <Control.Row>
                        <Control.DateRange
                            name="dates"
                            label={t("n2ixbxnqjkr")}
                            disabled={!_.get(data, "roomId")}
                            tooltipLabel={t("gnq2qw4kt8f")}
                            allowed={dateRange}
                            isRequired
                        />
                    </Control.Row>
                    <Control.Textarea name="comment" label={t("eweceyd5s3f")} placeholder={t("j687fzzn59")} />
                    <strong>{t("ir3sp6uq27s")}</strong>
                    <Control.Row>
                        <Control.Radio
                            label={t("czmoetb8ii8")}
                            checked={_.get(data, `author.role`) === ERoles.University}
                            onChange={(e) => setValue(`author.role`, e.target.value === `on` ? ERoles.University : ERoles.Student)}
                        />
                        <Control.Radio
                            label={t("q5m2npd6rhj")}
                            checked={_.get(data, `author.role`) === ERoles.Student}
                            onChange={(e) => setValue(`author.role`, e.target.value === `on` ? ERoles.Student : ERoles.University)}
                        />
                    </Control.Row>
                    <Control.Input
                        name="author.name"
                        label={data?.author?.role === ERoles.University ? `Наименование образовательной организации` : `ФИО`}
                        placeholder={data?.author?.role === ERoles.University ? `Наименование образовательной организации` : `ФИО`}
                        isRequired
                    />
                    <strong>{t("jrgzgl2efon")}</strong>
                    <Control.Input
                        name="author.contacts.committee"
                        label={t("3hqm15s36bg")}
                        placeholder={t("g0s6ogjqozg")}
                        extra={data?.author?.role === ERoles.Student && `display: none;`}
                        isRequired
                    />

                    <Control.Row>
                        <Control.Input
                            name="author.contacts.phone"
                            label={t("0x4obb4l2abg")}
                            placeholder={t("ga1zggcwsvh")}
                            // regex="[^0-9+]"
                            isRequired
                        />
                        <Control.Input name="author.contacts.email" label={t("ej00wd64z2j")} placeholder={t("ryaiafh5laq")} isRequired />
                    </Control.Row>

                    <Control.Input name="author.additionalInformation" label={t("htyuyha0vr")} placeholder={t("tqt5ptoyv6b")} />

                    <Control.Textarea name="studentsList" label={t("htyuyha0ve")} placeholder={t("htyuyha0ve")} />

                    <Control.File
                        name="files"
                        label={t("9bvpek1gpr")}
                        multiple
                        dropzoneProps={{
                            label: `Загрузить файлы (не более 5Мб, формат PDF, TXT, DOC)`,
                            icon: `dropzone-file`,
                        }}
                        accept={"image/*, application/pdf, application/msword"}
                    />

                    <Control.Row extra="gap: 10px; @media (max-width: 991px) { > * { width: 100%; }; };">
                        <Button variant="outlined" onClick={handlers.cancel}>
                            {t("meaj7wzzibl")}
                        </Button>
                        <Button type="submit">{mode === "create" ? t("fb9j0vjw3t") : t("p5rz91n2azr")}</Button>
                    </Control.Row>
                </Control.Form>
                {isDesktop && (
                    <DormitoryCard.Component
                        {...dormitory}
                        university={_.get(universities, `${universityId}.details`)}
                        rooms={_.map(_.values(rooms), `details`)}
                    />
                )}
            </RowWrapper>
        </Container>
    );
};

const DormitoryCard = {
    Component: (dormitory: any) => {
        const price = {
            min: Math.min(...dormitory?.rooms?.map?.((i) => +i?.price)),
            max: Math.max(...dormitory?.rooms?.map?.((i) => +i?.price)),
        };
        return (
            <DormitoryCard.Wrapper>
                <DormitorySearchPreview.Photo
                    src={resolveFileUrl(_.get(dormitory, `main-info.photos[0]`))}
                    extra={`width: 100%; height: 206px; border-radius: 8px 8px 0 0;`}
                />
                <Frame extra={`width: inherit; padding: 18px 24px; box-sizing: border-box; align-items: flex-start;`}>
                    <h3>{_.get(dormitory, `main-info.name`)}</h3>
                    <div className="uni-name">{_.get(dormitory, `university.name`)}</div>
                    <div className="region">{_.get(dormitory, `main-info.region`)}</div>
                    {[
                        { label: `Тип размещения`, value: dormitory?.rooms?.map?.((i) => i?.type)?.join(`\n`) },
                        {
                            label: `Питание`,
                            value: MEAL_PLAN_OPTIONS?.find?.((i) => i?.value === _.get(dormitory, `main-info.mealPlan`))?.label,
                        },
                        {
                            label: `Стоимость на 1 человека:`,
                            value: `${price.min}${price.max !== price.min ? ` - ${price.max}` : ``} ₽ в сутки`,
                        },
                    ].map(({ label, value }, index) => (
                        <RowWrapper
                            key={index}
                            extra={`> * { width: 100%; flex: 1; justify-content: flex-start; }; align-items: flex-start; gap: 10px; margin-top: 10px;`}
                        >
                            <div>{label}</div>
                            <strong>
                                {value?.split?.(`\n`)?.map?.((item, index) => (
                                    <div key={index}>{item}</div>
                                ))}
                            </strong>
                        </RowWrapper>
                    ))}
                </Frame>
            </DormitoryCard.Wrapper>
        );
    },
    Wrapper: styled(DormitorySearchPreview.Wrapper)`
        flex-direction: column;
        width: max-content;
        overflow: unset;
        /* min-width: 447px; */

        > * {
            max-width: 500px;
        }
    `,
};

export default CreateBookingPage;
